if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
const newMaxAge = [
    { name: "Royalton Habana", id: 10905 },
    { name: "Grand Memories Cayo Largo", id: 14860 },
    { name: "Grand Memories Holguin", id: 14861 },
    { name: "Grand Memories Santa Maria", id: 14862 },
    { name: "Grand Memories Varadero", id: 14863 },
    { name: "Memories Cayo Largo", id: 14864 },
    { name: "Memories Flamenco Beach Resort", id: 14865 },
    { name: "Memories Miramar Habana", id: 14859 },
    { name: "Memories Paraiso Beach Resort", id: 14866 },
    { name: "Memories Trinidad Del Mar", id: 14867 },
    { name: "Memories Varadero Beach Resort", id: 14868 },
    { name: "Starfish Cayo Guillermo", id: 14838 },
    { name: "Starfish Cayo Largo", id: 14839 },
    { name: "Starfish Cayo Santa Maria", id: 14840 },
    { name: "Starfish Jibacoa", id: 14847 },
    { name: "Starfish Montehabana", id: 14843 },
    { name: "Starfish Varadero", id: 14845 },
    { name: "Mystique Habana", id: 10911 },
    { name: "Mystique Trinidad", id: 10895 },
    { name: "Mystique Holguin Saratoga", id: 14903 },
    { name: "No match", id: 0 }
    ];
let selectSiteId = 0;
let siteIdAge = 0;

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    let property_type = document.querySelector( "select#property_type" )
    if( property_type ){

        let resort_list__unit = document.querySelectorAll( ".resort-list__unit" )
        property_type.addEventListener( "change", ( e ) => {

            let filter = e.target.value
            resort_list__unit.forEach( e => {

                if( e.dataset.type == filter  || filter == "All" )
                    e.classList.remove( "hidden" )
                else
                    e.classList.add( "hidden" )

            } )

        } )

        let property_destination = document.querySelector( "#property_destination" )
        property_destination.addEventListener( "change", ( e ) => {

            let filter = e.target.value

            resort_list__unit.forEach( e => {

                if( e.dataset.dest == filter || filter == "All" )
                    e.classList.remove( "hidden" )
                else
                    e.classList.add( "hidden" )

            } )

        } )

        let resort_list__filter_reset = document.querySelector( ".resort-list__filter-reset" )
        resort_list__filter_reset.addEventListener( "click", () => {
            property_type.value = "All"
            property_destination.value = "All"

            property_type.dispatchEvent(new Event('change'));
            property_destination.dispatchEvent(new Event('change'));
        } )
    }

    function getSiteId(dataName) {
        const match = newMaxAge.find(hotel => hotel.name === dataName)
        const noMatch = newMaxAge.find(hotel => hotel.name === 'No match')
        return match ? match : noMatch;
    }
    
    function restrictionAge(siteId) {
        const checkId = Number(siteId)
        const hotelId = newMaxAge.map(hotel => hotel.id === checkId).some(e => e === true)
        return hotelId ? 13 : 18;
    }

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    let children1 = [],
        children2 = [];
    $('.sym-slides').slick({
        accessibility: false
    });


    if( $(".gallery-block__list").length > 0 ){
        $(".gallery-block__list").slick({
            infinite: true,
            slidesToShow: 3,
            accessibility: true,
            speed: 700,
            dots: false,
            arrows: true,
            slidesToShow: 3,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    $('.header__languages-label').click(function(e) {
        e.preventDefault();
        $('.header__languages-dropdown').slideToggle('active');
    }); 

    $('.child').change(function () {
        
        let total;
        if (selectSiteId != 0) {
            total = restrictionAge(selectSiteId)
            siteIdAge = selectSiteId;
            selectSiteId = 0;
        } else {
            total = restrictionAge(site_id);
        }
        

        const numKids = $(this).val(),
                loc   =  $(this).data('loc');
        let   formId = '#booking-form',
                opts  = [];

        if(loc=='home'){
            formId = '#booking-form2'
        }

        $(`${formId} .child-age`).html('')

        if(numKids > 0) {
            
            for (let index = 1; index <= numKids; index++) {
                children1[index-1] = 0;
                children2[index-1] = 0;
                ageindex = (siteIdAge == 14903 ? 2 : 0);
                opts.push( $("<option />", {value: 'Select', text: 'Select'}));
                for (let index = ageindex; index < total; index++) {
                    opts.push( $("<option />", {value: index, text: index}));
                }
                const sChild = $(`<select id='children${index}'  name='children${index}'   class='childrenAge' />`),
                    divChild = $(`<div class='child-age__unit'><label for="children${index}">Age</label></div>`);
                sChild.append(opts);
                divChild.append(sChild);
                $(`${formId} .child-age`).append(divChild);
                opts =[];
            }
            $(`${formId} .child-age`).fadeIn();
            $(`${formId} .childages`).val('');
            //Eventlistener.
            $('.childrenAge').change(function () {
                const age = $(this).val(),
                    id = $(this).attr('id').replace('children','');
        
                if(formId=='#booking-form'){
                    children1[id-1] =age;
                    $(`${formId} .childages`).val(children1.join('|'));
                }else{   
                    children2[id-1] =age;
                    $(`${formId} .childages`).val(children2.join('|'));
                }
            })
        } else {
            $(`${formId} .child-age`).fadeOut();
            $(`${formId} .childages`).val('');
            opts =[];
        }

    }); 

    // $('.js-dynamic-properties, #properties1, #properties2').change(function(){
    //     const resort_acceptance = $(this).find(':selected').data('resort_acceptance'),
    //             trackclass = $(this).find(':selected').data('track'),
    //             form       = $(this).closest("form"),
    //             formId     = $(form).attr('id'),
    //             sizeAdults = $(this).find(':selected').data('length_adults'),
    //             sizeKids   = $(this).find(':selected').data('length_kids'),
    //             hotelName = $(this).find(':selected').data('name');
            
    //         $(`#${formId} .bookNow`).addClass(trackclass);
    //         $(`#${formId} .bookNow`).addClass("bookNow btn solid");

    //     selectSiteId = getSiteId(hotelName).id;

    //     if(resort_acceptance=='Adults Only')
    //         $(`#${formId} .field.guests.kids`).hide();
    //     else
    //         $(`#${formId} .field.guests.kids`).show();

    //     reloadSelect($(form).find('select[name="adult"]'),sizeAdults)
    //     reloadSelect($(form).find('select[name="child"]'),sizeKids)
    //     $(`${formId} .child-age`).fadeOut();
    //     $(`${formId} .childages`).val('');
    //     children1 = []
    //     children2 = []
    // });
    

    // $('.properties__select li').click(function(){
    //     const resort_acceptance = $(this).data('resort_acceptance'),
    //           trackclass = $(this).data('track'),
    //           form       = $(this).closest("form"),
    //           formId     = $(form).attr('id'),
    //           sizeAdults = $(this).data('length_adults'),
    //           sizeKids   = $(this).data('length_kids');
              
    //         $(`#${formId} .bookNow`).addClass(trackclass);
    //         $(`#${formId} .bookNow`).addClass("bookNow btn solid");

    //     console.log(resort_acceptance);

    //     if(resort_acceptance=='Adults Only')
    //         $(`#${formId} .field.guests.kids`).hide();
    //     else
    //         $(`#${formId} .field.guests.kids`).show();

    //     reloadSelect($(form).find('select[name="adult"]'),sizeAdults)
    //     reloadSelect($(form).find('select[name="child"]'),sizeKids)
    //     $(`${formId} .child-age`).fadeOut();
    //     $(`${formId} .childages`).val('');
    //     children1 = []
    //     children2 = []
    // });
    
    //contact event click
    if(window.location.pathname.indexOf('/contact')!==-1){
        $("select[name='resort_name']").change(function(e){
            e.preventDefault();
            switch (this.value) {
                case 'PLANET HOLLYWOOD CANCUN':
                    $("#form_id-104 input[name='sendto']").val('econciergepca-cun@planethollywoodhotels.com');
                    break;
                case 'PLANET HOLLYWOOD CANCUN ADULT SCENE':
                    $("#form_id-104 input[name='sendto']").val('econciergepca-cun@planethollywoodhotels.com');
                    break;
                case 'PLANET HOLLYWOOD COSTA RICA':
                    $("#form_id-104 input[name='sendto']").val('communitypcr-lir@planethollywoodhotels.com');
                    break;
            
                default:
                    $("#form_id-104 input[name='sendto']").val('info@planethollywoodhotels.com');
                    break;
            }
        })
    } 

    document.addEventListener('DOMContentLoaded', () => {
         if( document.querySelector(`.reviewsAwards_tabs`) && document.querySelector(`.reviewsAwards_holder`) ){
            switchReviewsAwardsTabs();
         }
    });
    
})();

function reloadSelect(selectId,size){
    
    selectId.html('');
    
    if(size.length==0 && selectId.attr('name')=='adult'){
        size = 8  
    }else if(size.length==0 && selectId.attr('name')!='adult'){
        size = 4
    }

    let labelField = '',
        valueField = 0;
    if(selectId.attr('name')=='adult'){
        valueField = 2;
        if(langSelected=='en')
            labelField  = 'Adults'
        else
            labelField  = 'Adultos'
    }else{
        valueField = 0;
        if(langSelected=='en')
            labelField  = 'Kids'
        else
            labelField  = 'Niños'
    }
    
    selectId.append($('<option>', {value: valueField,text: labelField}));
    for (let index = 1; index <= size; index++) {
        selectId.append($('<option>', {value: index,text: index}));
    }
}

function switchReviewsAwardsTabs(){
    let allOptionTabs = document.querySelectorAll(`.reviewsAwards_tabs li[data-tab]`);
    let allTabsToHandle = document.querySelectorAll(`.reviewsAwards_holder article[data-tab]`);
    let beforeOptionActive = null;

    allOptionTabs.forEach( option => {
        option.addEventListener( "click" , () => {
            allTabsToHandle.forEach( container => {
                if( option.dataset.tab == container.dataset.tab ){
                    container.classList.remove('container-hide');
                    container.removeAttribute('aria-hidden');
                    option.classList.add('active');
                }else{
                    container.classList.add('container-hide');
                    container.setAttribute('aria-hidden', 'true');
                    if( beforeOptionActive ){
                        beforeOptionActive.classList.remove('active');
                    }
                }
            } );

            beforeOptionActive = option;
        } );
    } );

    allOptionTabs[0].click();
}